import PropTypes from "prop-types"
import { useEffect, useState } from "react"

import Image from "components/ui/image"
import { cn } from "styles/utils"

const ProductImage = ({ alt, images, inLanding, index, styleCode, type }) => {
  const [hover, setHover] = useState(false)
  const [mainImg, setMainImg] = useState(images[0])
  const [hovImg, setHovImg] = useState(images[1])

  useEffect(() => {
    setMainImg(images[0])
    setHovImg(images[1])
  }, [images[0]])

  let productImage = hover ? hovImg : mainImg
  let placeholder = getPlaceholderData(type)

  return (
    <Image
      alt={alt}
      className={cn(
        "tablet:max-w-256 widescreen:max-w-300 mx-auto h-auto w-full max-w-full",
        "[&.lazyloading]:shimmer"
      )}
      data-cy={`collection-product-img-${styleCode}`}
      fallback={require(
        `images/collections/placeholder_masks/${
          placeholder[0]
        }_${(index % placeholder[1]) + 1}.svg`
      )}
      height="1024"
      onMouseEnter={() => !inLanding && images[1] && setHover(true)}
      onMouseLeave={() => !inLanding && setHover(false)}
      sizes="(max-width: 767px) 50vw,
             (max-width: 1023px) 33vw,
             (max-width: 1439px) 256px,
             300px"
      srcSet={productImage}
      width="1024"
    />
  )
}

ProductImage.propTypes = {
  alt: PropTypes.string,
  images: PropTypes.array,
  inLanding: PropTypes.bool,
  index: PropTypes.number,
  styleCode: PropTypes.string,
  type: PropTypes.string,
}

export const getPlaceholderData = (type) => {
  switch (type) {
    case "ring":
      return ["ring", 6]
    case "jlux":
      return ["jlux", 6]
    case "earring":
      return ["earring", 2]
    case "bracelet":
      return ["bracelet", 1]
    case "pendant":
    case "necklace":
    case "nameplate":
      return ["pendant", 1]
    default:
      return ["ring", 6]
  }
}

export default ProductImage
